// Shared brand assets for the admin panel.
// TODO: paste the same LOGO url you use in the client site's Navbar.js
export const LOGO = "https://res.cloudinary.com/dj6wdsbtx/image/upload/v1793161029/WhatsApp_Image_2026-10-27_at_8.51.41_AM-removebg-preview_xrmlsr.png";

export const HERO_SLIDES = [
  {
    src: "https://res.cloudinary.com/dj6wdsbtx/image/upload/v1791732731/Golden-Hour_Drilling_in_the_Valley_mcazyh.png",
    alt: "Drilling rig working in a valley at golden hour",
  },
  {
    src: "https://res.cloudinary.com/dj6wdsbtx/image/upload/v1791732733/Golden-Hour_Water_Well_Operation_alcqbk.png",
    alt: "Water well operation at golden hour",
  },
  {
    src: "https://res.cloudinary.com/dj6wdsbtx/image/upload/v1791732733/Solar_Installation_at_Golden_Hour_fpk7wv.png",
    alt: "Solar panels being installed at golden hour",
  },
];